import React, { useEffect } from "react";
import { useSelector, shallowEqual,useDispatch } from "react-redux";

import NoteGroup from "../../WorkkardDetail/MiddlePanelContainer/Notes/noteGroup";
import {fetchSearchResultData} from "../actions/action";
import ListingComponent from "../../../components/ListingComponent";
import * as _ from 'lodash';
import EmptyScreen from '../../../Emptyscreen';
import LoaderComponent from '../../../components/Loader';

const Notes =(props)=>{
    const { globalSearch } = useSelector(state => ({
        globalSearch: state.header.globalSearch
    }), shallowEqual);

    const dispatch=useDispatch();

    const dataPayload = {
        skip: 0,
        take: 100,
        isSearch: true,
        sortDir: 'ASC',
        sortBy: 1,
        rows: 100,
        displayCount: 100,
        status: 'notes',
        _: new Date()
    };

    useEffect(() => {
        const payload={
            ...dataPayload
        };
        payload.key = props.searchString;        
        dispatch(fetchSearchResultData(payload));
      }, []);

    const renderListing=(notes)=>{
        if (notes && notes.length > 0) {
            const noteIds = notes.map(item=>{
                const date = item.PrettyCreatedDate.split('at');
                return {id:item.Id, date:date[0], time:date[1], data: item}
            });
            const groupNoteIds = _.groupBy(noteIds, 'date');
            const prop = {
              data: Object.keys(groupNoteIds).map(key=>({key,data:groupNoteIds[key]})),
              cellTemplate: NoteGroup,
              onScrollHandler: onScrollHandler,
              onItemClick: () => false,
              type:"div",
              selectedId: '',
              classname:'scrollArea',
            }

            return (
                <React.Fragment>
                    <ListingComponent {...prop}/>
                </React.Fragment>
            );
        }
        return <EmptyScreen name="Emptynotes"/>;
    }

    const onScrollHandler=()=>{
        const { skip, take,Total} = globalSearch.notes;
        const payload={
            ...dataPayload
        };
        payload.key = props.searchString;
        payload.take = (skip === 0 && take > 20 ) ? 20 : parseInt(take);
        payload.skip = (skip === 0 && take > 20 ) ? take : parseInt(skip)+parseInt(take);
        payload.rows = (skip === 0 && take > 20 ) ? 20 : parseInt(take);
        payload.isUpdate = true;
        if(skip+take < Total){
            dispatch(fetchSearchResultData(payload));
        }
    }

    return (
        <div className={`notesMainContainer detailMainContainer ${globalSearch.notes.Data.length ==0 ? `noDataFound`:''}`}>
            {
                globalSearch.isLoading && !props.showResult && <LoaderComponent/>
            }
            {
                globalSearch.notes.status != null &&
                (
                    globalSearch.notes.status != 200 ?
                    <EmptyScreen name="Errorscreen" onRefreshClick={()=>dispatch(fetchSearchResultData(Object.assign({},dataPayload,{key:props.searchString})))}/>
                    :
                    globalSearch.activeTab==2 && renderListing(globalSearch.notes.Data)
                )
            }
        </div>
    )
}

export default Notes;
